import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import goodsOptions from "../../../components/serverList/goodsOptions.vue";
import { getGameGoodsMap } from "@/utils/dictionary";
export default {
  name: "fillEmailMsg",
  components: {
    goodsOptions: goodsOptions
  },
  props: {
    form: Object
  },
  data: function data() {
    return {
      //减少一行物品配置按钮
      goodsList: {},
      goodsArray: [],
      coinReduceBtn: false,
      sel_state: 0,
      isTimeSend: {
        0: "关闭",
        1: "开启"
      },
      timer: ""
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameGoodsMap();
            case 2:
              _this.goodsList = _context.sent;
              for (index in _this.goodsList) {
                _this.goodsArray.push({
                  goodsId: index,
                  goodsName: _this.goodsList[index]
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    changeSwitch: function changeSwitch(e) {
      this.sel_state = e;
    },
    //新增一个个物品配置
    addGoodsMsg: function addGoodsMsg() {
      this.form.item_list.push({
        item_id: "",
        num: 1
      });
      this.coinReduceBtn = true;
    },
    //减少一个个物品配置，第一个减号不能点击
    reduceGoodsMsg: function reduceGoodsMsg(index) {
      for (var i = 1; i < this.form.item_list.length; i++) {
        if (index === i) {
          this.form.item_list.splice(i, 1);
        }
      }
    }
  }
};